export const IconBack = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const IconChevronRight = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

/** 添加列表入口：列表/单据线框 ICON */
export const IconApplyList = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4.5" y="3.5" width="13" height="15" rx="2" stroke="currentColor" stroke-width="1.5" />
    <path d="M7.5 8h7M7.5 11h7M7.5 14h5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
  </svg>
);
